import { render, staticRenderFns } from "./listReserva.vue?vue&type=template&id=54714a5a&scoped=true"
import script from "./listReserva.vue?vue&type=script&lang=js"
export * from "./listReserva.vue?vue&type=script&lang=js"
import style0 from "./listReserva.vue?vue&type=style&index=0&id=54714a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54714a5a",
  null
  
)

export default component.exports